<script>
import DraggableList from '../form-components/DraggableList.vue'
import simplebar from "simplebar-vue";
import Label from '../form-components/Label.vue';
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true
    },
    prevSelectedItem: {
      type: String,
      required: true
    },
    setSelectedItems: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    DraggableList,
    simplebar, Label
  },
  data() {
    return {
      listData: [],
      category: null,
    }
  },
  computed: {
    totalItems() {
      return this.listData.length;
    },
    totalActiveItems() {
      return this.listData.filter((x => x.active == true)).length;
    }
  },
  methods: {
    setListItems(val, sort) {
      if(sort) this.listData = val.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
      else this.listData = val;
    },
  },
  async mounted() {
    const data = await categoryService.get(this.$route.params.categoryId)
    this.category = data;
    let types = data.additionalProp1.types;

    if(types && types.length) this.setListItems(types, false)
    else this.setListItems([], false)
  }
};
</script>
<template>
  <div v-if="listData.length">
    <simplebar class="simplebar-custom"
    id="scrollElement"
    data-simplebar-auto-hide="false"
  >
    <Label v-if="!item.empty" :item="item" :total_items="totalItems" :total_active_items="totalActiveItems"/>
    <DraggableList v-if="item.draggable" :variant="item.variant" :list="listData" :selectedItem="selectedItem"
    :setSelectedItems="setSelectedItems" :prevSelectedItem="prevSelectedItem" :topbarControls="topbarControls"
    />  
    </simplebar>
  </div>
  <div v-else></div>
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>